"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sampleSpan = sampleSpan;

var _currentScopes = require("../currentScopes.js");

var _debugBuild = require("../debug-build.js");

var _logger = require("../utils-hoist/logger.js");

var _hasTracingEnabled = require("../utils/hasTracingEnabled.js");

var _parseSampleRate = require("../utils/parseSampleRate.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */
function sampleSpan(options, samplingContext) {
  // nothing to do if tracing is not enabled
  if (!(0, _hasTracingEnabled.hasTracingEnabled)(options)) {
    return [false];
  } // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation


  const normalizedRequest = (0, _currentScopes.getIsolationScope)().getScopeData().sdkProcessingMetadata.normalizedRequest;

  const enhancedSamplingContext = _objectSpread(_objectSpread({}, samplingContext), {}, {
    normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
  }); // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so


  let sampleRate;

  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(enhancedSamplingContext);
  } else if (enhancedSamplingContext.parentSampled !== undefined) {
    sampleRate = enhancedSamplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
  } // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
  // (The only valid values are booleans or numbers between 0 and 1.)


  const parsedSampleRate = (0, _parseSampleRate.parseSampleRate)(sampleRate);

  if (parsedSampleRate === undefined) {
    _debugBuild.DEBUG_BUILD && _logger.logger.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    return [false];
  } // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped


  if (!parsedSampleRate) {
    _debugBuild.DEBUG_BUILD && _logger.logger.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
    return [false, parsedSampleRate];
  } // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.


  const shouldSample = Math.random() < parsedSampleRate; // if we're not going to keep it, we're done

  if (!shouldSample) {
    _debugBuild.DEBUG_BUILD && _logger.logger.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [false, parsedSampleRate];
  }

  return [true, parsedSampleRate];
}